import { render, staticRenderFns } from "./emailTemplates.vue?vue&type=template&id=c27e6d96&scoped=true&"
import script from "./emailTemplates.vue?vue&type=script&lang=js&"
export * from "./emailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./emailTemplates.vue?vue&type=style&index=0&lang=css&"
import style1 from "./emailTemplates.vue?vue&type=style&index=1&id=c27e6d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27e6d96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c27e6d96', component.options)
    } else {
      api.reload('c27e6d96', component.options)
    }
    module.hot.accept("./emailTemplates.vue?vue&type=template&id=c27e6d96&scoped=true&", function () {
      api.rerender('c27e6d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\activities\\emailTemplates.vue"
export default component.exports